module.exports = {
    "development": {
        "localhost:8080": {
			url: "http://localhost:7000"
		}
    },
    "production": {
        "kiosk.mediport.partheas.net": {
            url: "https://api.mediport.partheas.net"
        },
        "kiosk.cdg.partheas.net": {
            url: "https://api.cdg.partheas.net"
        },
        "kiosk.medicis.partheas.net": {
            url: "https://api.medicis.partheas.net"
        },
        "kiosk.ocs.partheas.net": {
            url: "https://api.ocs.partheas.net"
        },
        "kiosk.partheas.partheas.net": {
            url: "https://api.partheas.partheas.net"
        },
        "kiosk.beukenlaan.partheas.net": {
            url: "https://api.beukenlaan.partheas.net"
        },
        "kiosk.devaart.partheas.net": {
            url: "https://api.devaart.partheas.net"
        },
        "kiosk.dhaacht.partheas.net": {
            url: "https://api.dhaacht.partheas.net"
        },
        "kiosk.dkl.partheas.net": {
            url: "https://api.dkl.partheas.net"
        },
        "kiosk.dleie.partheas.net": {
            url: "https://api.dleie.partheas.net"
        },
        "kiosk.cpdiest.partheas.net": {
            url: "https://api.cpdiest.partheas.net"
        },
        "kiosk.dermatokliniek.partheas.net": {
            url: "https://api.dermatokliniek.partheas.net"
        },
        "kiosk.grimbergen.docleas.eu": {
            url: "https://api.grimbergen.docleas.eu"
        },
        "kiosk.torhout.docleas.eu": {
            url: "https://api.torhout.docleas.eu"
        },
        "kiosk.erpe-mere.docleas.eu": {
            url: "https://api.erpe-mere.docleas.eu"
        },
        "kiosk.oostkamp.docleas.eu": {
            url: "https://api.oostkamp.docleas.eu"
        },
        "kiosk.lochristi.docleas.eu": {
            url: "https://api.lochristi.docleas.eu"
        },
        "kiosk.kraainem.docleas.eu": {
            url: "https://api.kraainem.docleas.eu"
        },
        "kiosk.nottebohm.partheas.net": {
            url: "https://api.nottebohm.partheas.net"
        },
        "kiosk.berlaar.docleas.eu": {
            url: "https://api.berlaar.docleas.eu"
        },
        "kiosk.sint-lievens-houtem.docleas.eu": {
            url: "https://api.sint-lievens-houtem.docleas.eu"
        },
        "kiosk.vermeulenlaan.partheas.net": {
            url: "https://api.vermeulenlaan.partheas.net"
        },
        "kiosk.bkz.docleas.eu": {
            url: "https://api.bkz.docleas.eu"
        },
        "kiosk.brakel.docleas.eu": {
            url: "https://api.brakel.docleas.eu"
        },
        "kiosk.stekene.docleas.eu": {
            url: "https://api.stekene.docleas.eu"
        },
        "kiosk.blankenberge.docleas.eu": {
            url: "https://api.blankenberge.docleas.eu"
        },
        "kiosk.hippocrates.partheas.net": {
            url: "https://api.hippocrates.partheas.net"
        },
        "kiosk.dermatologie-roeselare.partheas.net": {
            url: "https://api.dermatologie-roeselare.partheas.net"
        },
        "kiosk.dehuidkliniek.partheas.net": {
            url: "https://api.dehuidkliniek.partheas.net"
        },
        "kiosk.hvrt.partheas.net": {
            url: "https://api.hvrt.partheas.net"
        },
        "kiosk.kade21.partheas.net": {
            url: "https://api.kade21.partheas.net"
        },
        "kiosk.havik-herentals.partheas.net": {
            url: "https://api.havik-herentals.partheas.net"
        },
        "kiosk.zelzate.docleas.eu": {
            url: "https://api.zelzate.docleas.eu"
        },
        "kiosk.sint-genesius-rode.docleas.eu": {
            url: "https://api.sint-genesius-rode.docleas.eu"
        },
        "kiosk.halen.docleas.eu": {
            url: "https://api.halen.docleas.eu"
        },
        "kiosk.assenede.docleas.eu": {
            url: "https://api.assenede.docleas.eu"
        },
        "kiosk.wetteren.docleas.eu": {
            url: "https://api.wetteren.docleas.eu"
        },
        "kiosk.depanne.docleas.eu": {
            url: "https://api.depanne.docleas.eu"
        },
        "kiosk.derma-hasselt.partheas.net": {
            url: "https://api.derma-hasselt.partheas.net"
        },
        "kiosk.derma-diest.partheas.net": {
            url: "https://api.derma-diest.partheas.net"
        },
        "kiosk.eliaerts.partheas.net": {
            url: "https://api.eliaerts.partheas.net"
        },
        "kiosk.mirha.partheas.net": {
            url: "https://api.mirha.partheas.net"
        },
        "kiosk.nkopraktijk.partheas.net": {
            url: "https://api.nkopraktijk.partheas.net"
        },
        "kiosk.overijse.docleas.eu": {
            url: "https://api.overijse.docleas.eu"
        },
        "PRODUCTION.TENANT_19": {
            url: "PRODUCTION.TENANT_19_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_20": {
            url: "PRODUCTION.TENANT_20_API_REDIRECT_URL"
        }
    }
}